import * as React from 'react';
import BasicCard from '../BasicCard';



import Dummylayout from '../Dummylayout';

import SubCategoryTable from './SubCategoryTable';



function SubCategoryData() {
    return (
        <>
           <div> <Dummylayout/></div>
        <div className='' > <BasicCard>
                {/* <Filter/> */}
     <div className='row border-1'>
    
     
      </div>
      
                <SubCategoryTable/>

            </BasicCard>
            </div>  
        </>
    )
}
export default SubCategoryData;